import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i2 from '@yourcause/common/i18n';
import { I18nModule } from '@yourcause/common/i18n';

class WordCounterComponent {
    constructor() {
        this.showWordCount = true;
        this.showCharCount = false;
        this.showMaxLength = false;
        this.wordCount = 0;
        this.charCount = 0;
    }
    ngOnChanges() {
        if (this.showCharCount) {
            this.charCount = (this.inputValue || '').length;
        }
        if (this.showWordCount) {
            this.wordCount = (this.inputValue || '').trim().split(/\s+/).length;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WordCounterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: WordCounterComponent, selector: "yc-word-counter", inputs: { showWordCount: "showWordCount", showCharCount: "showCharCount", showMaxLength: "showMaxLength", maxLength: "maxLength", inputValue: "inputValue" }, usesOnChanges: true, ngImport: i0, template: "<span>\n  <!-- Char Count -->\n  <span *ngIf=\"showCharCount\">\n    <yc-i18n *ngIf=\"charCount > 1\"\n      [key]=\"showMaxLength ?\n        'common:textNumberOfCharactersWithMax' :\n        'common:textNumberOfCharacters'\"\n      [context]=\"{\n        number: charCount,\n        maxCharCount: maxLength\n      }\"\n      [defaultValue]=\"showMaxLength ?\n        '__number__ characters of __maxCharCount__' :\n        '__number__ characters'\">\n    </yc-i18n>\n    <yc-i18n *ngIf=\"charCount === 1\"\n      key=\"common:textOneCharacter\"\n      defaultValue=\"1 character\">\n    </yc-i18n>\n  </span>\n  <!-- Word Count -->\n  <span *ngIf=\"showWordCount\"\n    [class.ms-2]=\"showCharCount && charCount > 0\">\n    <yc-i18n *ngIf=\"wordCount > 1\"\n      key=\"common:textNumberOfWords\"\n      [context]=\"{\n        number: wordCount\n      }\"\n      defaultValue=\"__number__ words\">\n    </yc-i18n>\n    <yc-i18n *ngIf=\"wordCount === 1\"\n      key=\"common:textOneWord\"\n      defaultValue=\"1 word\">\n    </yc-i18n>\n  </span>\n</span>", styles: [""], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.I18nComponent, selector: "yc-i18n", inputs: ["key", "defaultValue", "context", "transform"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WordCounterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'yc-word-counter', template: "<span>\n  <!-- Char Count -->\n  <span *ngIf=\"showCharCount\">\n    <yc-i18n *ngIf=\"charCount > 1\"\n      [key]=\"showMaxLength ?\n        'common:textNumberOfCharactersWithMax' :\n        'common:textNumberOfCharacters'\"\n      [context]=\"{\n        number: charCount,\n        maxCharCount: maxLength\n      }\"\n      [defaultValue]=\"showMaxLength ?\n        '__number__ characters of __maxCharCount__' :\n        '__number__ characters'\">\n    </yc-i18n>\n    <yc-i18n *ngIf=\"charCount === 1\"\n      key=\"common:textOneCharacter\"\n      defaultValue=\"1 character\">\n    </yc-i18n>\n  </span>\n  <!-- Word Count -->\n  <span *ngIf=\"showWordCount\"\n    [class.ms-2]=\"showCharCount && charCount > 0\">\n    <yc-i18n *ngIf=\"wordCount > 1\"\n      key=\"common:textNumberOfWords\"\n      [context]=\"{\n        number: wordCount\n      }\"\n      defaultValue=\"__number__ words\">\n    </yc-i18n>\n    <yc-i18n *ngIf=\"wordCount === 1\"\n      key=\"common:textOneWord\"\n      defaultValue=\"1 word\">\n    </yc-i18n>\n  </span>\n</span>" }]
        }], propDecorators: { showWordCount: [{
                type: Input
            }], showCharCount: [{
                type: Input
            }], showMaxLength: [{
                type: Input
            }], maxLength: [{
                type: Input
            }], inputValue: [{
                type: Input
            }] } });

class WordCounterModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WordCounterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: WordCounterModule, declarations: [WordCounterComponent], imports: [CommonModule,
            I18nModule], exports: [WordCounterComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WordCounterModule, imports: [CommonModule,
            I18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WordCounterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        I18nModule
                    ],
                    declarations: [
                        WordCounterComponent
                    ],
                    exports: [
                        WordCounterComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { WordCounterComponent, WordCounterModule };
